import FingerprintJS from "@fingerprintjs/fingerprintjs";

// Initialize the agent at application startup.
const fpPromise = FingerprintJS.load();

/**
 * Fetches the FingerprintJS visitorId.
 * @returns {Promise<string|null>} The visitor identifier or null if failed.
 */
export const getVisitorId = async () => {
  try {
    const fp = await fpPromise;
    const result = await fp.get();
    return result.visitorId;
  } catch (error) {
    console.error("Fingerprint error:", error);
    return null;
  }
};
